import type {
  AppConfigs,
  AppConfigsResponse,
  Features,
} from "~/types/Data/Common/appConfigs";
import useTenant from "~/composables/Tenant/common/useTenant";

type ProvidedType =
  | {
      preview: boolean;

      appConfig?: AppConfigs;
      baseUrl: string;
      features?: Features;
      currency: string;
      langs: string[];
    }
  | undefined;

export default defineNuxtPlugin(async (nuxtApp) => {
  const { tenant, refresh } = useTenant();

  const { public: publicEnv } = nuxtApp.$config;
  const tenantBaseUrl = String(publicEnv.CMS_URL ?? "");

  let provided: ProvidedType = {
    preview: publicEnv.VERSION === "PREVIEW",
    langs: ["en"],
    baseUrl: tenantBaseUrl,
    currency: "EGP",
  };

  async function fetchAppConfigs(baseUrl: string) {
    const { data: config } = await useAsyncData("config", async () => {
      const { res } = await useApi<AppConfigsResponse>(
        "/api/v2/app_configs",
        {},
        {
          baseUrl,
        },
      );
      return res;
    });

    return config.value;
  }

  if (provided.preview && tenant.value?.url) {
    const configuration = await fetchAppConfigs(tenant.value.url);

    if (tenant.value.refresh_token) refresh();

    provided = {
      ...provided,
      preview: true,
      appConfig: configuration?.data,
      baseUrl: tenant.value.url,
      features: configuration?.data.features,
      currency: configuration?.data?.currency?.symbol ?? "EGP",
      langs: Object.keys(configuration?.data.selected_languages ?? {}),
    };
  } else {
    const config = await fetchAppConfigs(tenantBaseUrl);

    provided = {
      ...provided,
      preview: false,
      appConfig: config?.data,
      baseUrl: tenantBaseUrl,
      features: config?.data.features,
      currency: config?.data?.currency?.symbol ?? "EGP",
      langs: Object.keys(config?.data.selected_languages ?? {}),
    };
  }

  return {
    provide: provided,
  };
});
